// extracted by mini-css-extract-plugin
export default {"navLink":"Tabs_navLink__Q4zPq","active":"Tabs_active__yq8PN"};